import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { MessageCircle, Users } from "lucide-react";

export function WhatsAppShareButton({ svc }) {
  const share = async () => {
    const win = window.open("", "_blank");
    try {
      const { data } = await api.get(`/services/${svc.id}/whatsapp-text`);
      const url = `https://wa.me/?text=${encodeURIComponent(data.text)}`;
      if (win) win.location.href = url; else window.location.href = url;
    } catch (err) {
      if (win) win.close();
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };
  return (
    <Button size="sm" variant="ghost" title="Condividi su WhatsApp" data-testid={`whatsapp-share-${svc.id}`} onClick={share} className="text-[#25D366] hover:text-[#1da851] hover:bg-[#25D366]/10">
      <MessageCircle className="h-4 w-4" />
    </Button>
  );
}

export function WhatsAppDayButton({ date, week }) {
  const share = async () => {
    const base = date ? new Date(`${date}T12:00`) : new Date();
    if (week) base.setDate(base.getDate() - ((base.getDay() + 6) % 7));
    const day = base.toLocaleDateString("sv-SE");
    const win = window.open("", "_blank");
    try {
      const { data } = await api.get("/services-day/whatsapp-text", { params: { date: day, days: week ? 7 : 1 } });
      const url = `https://wa.me/?text=${encodeURIComponent(data.text)}`;
      if (win) win.location.href = url; else window.location.href = url;
    } catch (err) {
      if (win) win.close();
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };
  return (
    <Button size="sm" variant="outline" data-testid={week ? "whatsapp-week-share" : "whatsapp-day-share"} onClick={share}
      title={week ? "Condividi i servizi della settimana (lunedì-domenica)" : date ? "Condividi i servizi della data scelta" : "Condividi i servizi di oggi"}
      className="rounded-full h-9 border-[#25D366]/40 text-[#128C7E] hover:bg-[#25D366]/10">
      <MessageCircle className="h-4 w-4 mr-1" /> {week ? "Settimana" : date ? "Riepilogo del giorno" : "Riepilogo di oggi"}
    </Button>
  );
}

export function WhatsAppGroupLink({ svc }) {
  if (!svc.whatsapp_link) return null;
  return (
    <a href={svc.whatsapp_link} target="_blank" rel="noopener noreferrer" data-testid={`whatsapp-group-${svc.id}`}
      className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-[#25D366]/10 text-[#128C7E] border border-[#25D366]/30 px-3 py-1 text-xs font-semibold hover:bg-[#25D366]/20 transition-colors w-fit">
      <Users className="h-3.5 w-3.5" /> Entra nel gruppo WhatsApp
    </a>
  );
}
